export const fetchAbstract = async ($url: string, $obj: RequestInit) => {
  const fetchApi = await fetch($url, $obj)
  const response = await fetchApi.json()
  return response
}
